import { put, takeEvery, select } from 'redux-saga/effects'
import { EXTRAITEMS_LOADING, GET_EXTRAITEMS_DATA_SUCCESS, GET_EXTRAITEMS_DATA_ERROR } from "../actions/actionExtraItems";
import { apiExtraItems } from 'api';
import { GET_BOOKINGTYPE_DATA, GET_BOOKINGTYPES_DATA_SUCCESS } from "../actions/actionBookingTypes";
import { apiBookingTypes } from 'api';
import { GET_DISPLAYAREAS_DATA_SUCCESS } from "../actions/actionDisplayAreas";
import { apiDisplayAreas } from 'api';

async function fetchAsync(func, bookingID, nextTourDate, checkFromNextTourDate, isDisplayArea, isListView, currentView, listViewSearchDays, tourEventsList) {

  const response = await func(bookingID, nextTourDate, checkFromNextTourDate, isDisplayArea, isListView, currentView, listViewSearchDays, tourEventsList);

  if (response.ok && response.status == 200) {
    return await response.json();
  }
  else if (response.status == 204) {
    return "nocontent";
  }
  else if (response.status == 401) {
    throw new Error('Authorization has been denied for this request.');
  }
  else if (response.status == 404) {
    throw new Error('The Requested URL was not found.');
  }
  else if (!response.ok) {
    throw new Error('An expected error has occured while getting products, Please contact administrator.');
  }
}

function* fetchExtraItemsData(action) {
  try {

    let bkngTypes = yield select(state => state.reducerBookingTypes);
    let bookingType = yield select(state => state.reducerBookingTypes.bookingType);

    if (bkngTypes.bookingTypes === undefined || bkngTypes.bookingTypes.length < 1) {
      bkngTypes = yield fetchAsync(apiBookingTypes, action.payload, action.isDisplayArea);
    }
    else {
      bkngTypes = bkngTypes.bookingTypes;
    }

    if (bkngTypes && bkngTypes.length > 0 && !bookingType.hasOwnProperty('BookingTypeID')) {
      bookingType = bkngTypes[0];
    }

    let areaNumber;

    if (action.isDisplayArea) {
      let displayAreas = yield select(state => state.reducerDisplayAreas.displayAreas);
      let displayArea = yield select(state => state.reducerDisplayAreas.displayArea);

      if (displayAreas.length < 1) {

        if (displayArea && displayArea.hasOwnProperty('DisplayAreaNo') && displayArea.DisplayAreaNo == action.payload) {
          areaNumber = displayArea;
        }
        else {

          const data = yield fetchAsync(apiDisplayAreas, "bookingtypes")
          yield put({ type: GET_DISPLAYAREAS_DATA_SUCCESS, payload: data, id: action.payload, isDisplay: true });

          displayAreas = yield select(state => state.reducerDisplayAreas.displayAreas);

          if (displayAreas && displayAreas.length > 0) {
            areaNumber = displayAreas.filter(x => x.DisplayAreaNo == action.payload)[0];
          }

        }

      }
      else {
        areaNumber = displayAreas.filter(x => x.DisplayAreaNo == action.payload)[0];
      }

      if ((action.nextTourDate === undefined || action.nextTourDate === null) && areaNumber) {

        action.nextTourDate = displayAreas.filter(x => x.DisplayAreaNo == action.payload)[0].NextTourDate;
      }

      const data = yield fetchAsync(apiExtraItems, action.payload, action.nextTourDate,
        action.checkBookingTypeObj, action.isDisplayArea, action.isListView, action.currentView,
        action.isListView && action.isListView == true ? areaNumber.ListViewSearchDays : undefined,
        action.tourEventsList);

      yield put({ type: GET_EXTRAITEMS_DATA_SUCCESS, payload: data });
    }
    else {
      if (action.checkBookingTypeObj) {


        if ((bkngTypes && bkngTypes.length > 0 && bkngTypes.find(x => x.BookingTypeID === parseInt(action.payload)) !== undefined) ||
          (bookingType && bookingType.hasOwnProperty('BookingTypeID') && bookingType.BookingTypeID === parseInt(action.payload))) {

          var bookingTy = bkngTypes && bkngTypes.length > 0 ? bkngTypes.find(x => x.BookingTypeID === parseInt(action.payload)) : bookingType;
          let nextTourDate = undefined;

          if (action.nextTourDate !== undefined && action.nextTourDate !== null) {
            nextTourDate = action.nextTourDate;
          }

          else if (nextTourDate === undefined && bookingTy.hasOwnProperty('NextTourDate') && bookingTy.NextTourDate) {
            nextTourDate = bookingTy.NextTourDate;
          }

          var forceListView = action.isListView ? action.isListView : bookingTy.ForceListView;

          const data = yield fetchAsync(apiExtraItems, action.payload, nextTourDate,
            action.checkBookingTypeObj, false, forceListView, action.currentView,
            forceListView ? bookingTy.ListViewSearchDays : undefined,
            action.tourEventsList)

          yield put({ type: GET_EXTRAITEMS_DATA_SUCCESS, payload: data });
        }
      }
      else {
        const data = yield fetchAsync(apiExtraItems, action.payload, action.nextTourDate,
          action.checkBookingTypeObj, action.isDisplayArea, null, action.currentView, null, action.tourEventsList);

        yield put({ type: GET_EXTRAITEMS_DATA_SUCCESS, payload: data });
      }
    }
  } catch (e) {
    yield put({ type: GET_EXTRAITEMS_DATA_ERROR, error: e.message });
  }
}

export const sagaExtraItems = [
  takeEvery(EXTRAITEMS_LOADING, fetchExtraItemsData)
];
